import React, { useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import { Visibility, VisibilityOff, KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface ResetPasswordFormProps {
  isOtpVerified: boolean;
  password: string;
  confirmPassword: string;
  setPassword: (value: string) => void;
  setConfirmPassword: (value: string) => void;
  handleResetLoginDetails: () => void;
  id: string | null;
}

export const ResetPasswordForm = ({
  isOtpVerified,
  password,
  confirmPassword,
  setPassword,
  setConfirmPassword,
  handleResetLoginDetails,
  id
}: ResetPasswordFormProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {isOtpVerified && (
  <>
    <Typography variant="h6" gutterBottom align="center">
      Kennwort ändern
    </Typography>

    <Grid container justifyContent="center" sx={{ mb: 2 }}>
      <Grid item xs={12} md={6} lg={4}>
        <TextField
          label="Neues Kennwort"
          type={showPassword ? "text" : "password"}
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>

    <Grid container justifyContent="center" sx={{ mb: 2 }}>
      <Grid item xs={12} md={6} lg={4}>
        <TextField
          label="Bestätige das Passwort"
          type={showPassword ? "text" : "password"}
          fullWidth
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>

    <Grid container justifyContent="center" sx={{ mb: 2 }}>
      <Grid item xs={12} md={6} lg={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleResetLoginDetails}
          disabled={confirmPassword !== password}
          fullWidth
        >
          Passwort zurücksetzen
        </Button>
      </Grid>
    </Grid>

    {id && (
      <Grid container justifyContent="center">
        <Grid item xs={12} md={6} lg={4}>
          <Typography
            variant="body1"
            color="primary"
            onClick={() => navigate("/login")}
            style={{ cursor: "pointer", textAlign: "center" }}
          >
            <KeyboardBackspace />
            Zurück zur Anmeldung
          </Typography>
        </Grid>
      </Grid>
    )}
  </>
)}
    </>
  );
};
